<app-service-detail>
    <app-variables-tabs primarySelectedTab="CrossTables" class="container-fluid px-5">
    </app-variables-tabs>
    <div class="col-12 pl-md-5 ml-auto list-header">

        <h1 class="list-header-title">
            {{'Form Fields / Determinants' | translate}}
        </h1>
    </div>
    <div class="col-12 pl-5">
        <div class="row">
            <div class="col-md-12">
                <section class="table-container cross-table-container">
                    <section class="table-flip-scroll">
                        <table *ngIf="formFieldDeterminantRelationship.length"
                        class="table table-bordered table-striped cross-table fields-regs">
                            <thead>
                                <tr>
                                    <th>{{'crosstables.form_field' | translate}}</th>
                                    <th *ngFor="let item of formFieldDeterminantRelationship[0];">
                                        <span class="limited" title="{{ item.determinantName}}">
                                            {{ item.determinantName}}
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <fields-group-determinant 
                                    *ngFor="let group of formFieldsGroup;"
                                    [group]="group"
                                    [determinants]="formFieldDeterminantRelationship[0]"
                                    (onRelationChange)="openLayer($event)"></fields-group-determinant>
                            </tbody>
                        </table>
                    </section>
                </section>
            </div>
        </div>
    </div>

    <fields-determinant-edit
        *ngIf="determinantEdit"
        [serviceId]="serviceId"
        [componentKey]="determinantEdit.key"
        [determinantMapById]="determinantMapById"
        (changeDeterminants)="changeDeterminants($event)"
        (closeLayer)="closeDeterminantLayer()">
    </fields-determinant-edit>

</app-service-detail>
